import { indexItems } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-100/60">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900" style={{ fontFamily: 'var(--font-heading)' }}>
            吃瓜索引
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500">按话题领域浏览，快速找到你感兴趣的瓜</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {indexItems.map((item) => (
            <a
              key={item.title}
              href="#ranking"
              className="group flex items-start gap-4 p-5 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200/60 transition-all duration-200 cursor-pointer"
            >
              <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-200">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <div className="min-w-0">
                <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors" style={{ fontFamily: 'var(--font-heading)' }}>
                  {item.title}
                </h3>
                <p className="mt-1 text-xs text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
                <span className="inline-block mt-2 text-[11px] text-foreground-400 bg-background-100 px-2 py-0.5 rounded">{item.count}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}